"use client";

import React, { useEffect } from "react";

import WorkFairRegistrationForm from "@/components/workfair/WorkFairRegistrationForm";

export default function WorkFairRegistration(): JSX.Element {
  useEffect(() => {
    // Add the custom body class
    document.body.classList.add("wf-registration");

    // Clean up when the component is unmounted
    return () => {
      document.body.classList.remove("wf-registration");
    };
  }, []);

  return (
    <div className="md:max-w-[732px] py-10 md:px-[50px] flex flex-1 items-center justify-center m-auto">
      <div className="flex flex-col bg-white rounded-[20px] p-5 sm:p-8 w-full">
        <WorkFairRegistrationForm
          isModal={false}
          title="Register for WorkFair 2026"
          text="Complete the form below to register for WorkFair 2026."
          submitButtonText="Register"
          acknowledgmentTitle="Thank you for registering!"
          acknowledgmentText="A confirmation email has been sent to your registered email address."
        />
      </div>
    </div>
  );
}
